import _ from 'lodash';

// Sổ nháp điều hướng non-reactive, thay cho goto.devices. Xem spec §3.
// Kiểu lỏng là bắt buộc: devices.tsx ghi/đọc key động theo DEVICE_TABLE_TYPE.
const deviceNavigationState: Record<string, any> = {};

/**
 * Returns the devices screen's navigation memory to its defaults. Deletes every existing key from the shared device navigation state, then re-assigns an undefined tab and sub-tab, the 'All models' selection and empty search values.
 *
 * @returns Nothing.
 */
const resetDeviceNavigationState = () => {
  _.forEach(_.keys(deviceNavigationState), (key) => {
    delete deviceNavigationState[key];
  });
  _.assign(deviceNavigationState, {
    tab: undefined,
    subTab: undefined,
    select: { model: 'All models' },
    search: {
      searchValue: undefined,
      searchByValue: undefined,
    },
  });
};

resetDeviceNavigationState();

export { deviceNavigationState, resetDeviceNavigationState };
